

var _fn = require('xo-guest-components/src/fraudnet/fn');

var _gdprCookieBanner = require('xo-models/src/gdprCookieBanner');

var _logger = require('xo-beaver/dist/logger');

define(['angular', 'squid/index', 'text!./template.html', 'xo-ui-components/src/spinner/directive', 'xo-page-components/src/merchant-header/directive', 'xo-page-components/src/header/directive', 'xo-page-components/src/footer/directive', 'xo-page-components/src/cart/directive', 'xo-ui-components/src/error-tooltip/directive', 'xo-validation/dist/directive', 'xo-device-info/dist/index', 'xo-models/src/shippingMethod/index', 'xo-page-components/src/gdprCookieBanner/directive'], function (angular, squid, template) {

    return angular.module('hermes.page.xo-checkout.directive', ['squid', 'xo-spinner.directive', 'xo-merchant-header.directive', 'xo-header.directive', 'xo-footer.directive', 'xo-cart.directive', 'xo-error-tooltip.directive', 'xo-validation.directive', 'xo-device-info', 'xo-gdpr-cookie-banner.directive']).directive('xoCheckout', function ($document, $config, $util) {

        return {
            template: template,
            scope: {},

            controller: function controller($scope, $rootScope, $state, $renderContent, $locale, $LocaleResolver, $DeviceInfo, $FallbackError, $feature, $populate, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel) {

                $scope.guestAuthFlow = !!$util.param('atoSuccess');
                $scope.token = $rootScope.token;
                $scope.locale = $locale;

                _fn.$fn.trigger();
                $scope.isGdprValid = _gdprCookieBanner.isGdprValid;

                // Regulation E only applies to invoicing flows where a US payer is
                // sending money to a non-US receiver
                function isRegulationEApplicable() {
                    var checkoutAppData = $scope.checkoutAppData;

                    var isInvoicingFlow = checkoutAppData.isInvoiceFlow();
                    var isUSSender = $locale.country === 'US';
                    var isNonUSReceiver = checkoutAppData.merchant.merchant_country !== 'US';

                    return isInvoicingFlow && isUSSender && isNonUSReceiver;
                }

                function setLanguageToggleFlags() {
                    var landingPage = $scope.checkoutAppData.get('flags.landing_page');
                    var hermesLoginRedirectParam = $util.param('hermesLoginRedirect');
                    var languageToggleFeature = $feature('languageToggle');

                    // Language Toggle - header
                    if (landingPage === 'BILLING' && !hermesLoginRedirectParam || isRegulationEApplicable()) {
                        $scope.languageSwitchHeader = { show: languageToggleFeature };
                    } else {
                        $scope.languageSwitchFooter = { show: languageToggleFeature };
                    }
                }

                function checkShippingRulesExist() {
                    return $populate($scope, {
                        shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                            params: {
                                merchant_id: $scope.checkoutPayee.merchant.id,
                                currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                            }
                        })
                    });
                }

                function setButtonParams(isSnTEnabled) {
                    // We need instant update flow check here again, because all instant update flows will
                    // not have SnTEnabled in shippingRulesSummary
                    if (isSnTEnabled || $scope.checkoutCart.instantUpdateIntegration) {
                        // preserve these cart amount values passed from the merchant
                        // since they could get changed after SnT from profile/callback (in case instant update) is applied
                        // TODO: get rid of buttonParams and start using checkoutCart in SnT module
                        $scope.buttonParams = {
                            shipping: $scope.checkoutCart.purchase.amounts.shipping,
                            tax: $scope.checkoutCart.purchase.amounts.tax,
                            total: $scope.checkoutCart.purchase.amounts.total
                        };
                    }
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    setLanguageToggleFlags();

                    var isSntSupported = $scope.checkoutAppData.is_snt_supported();

                    // call checkShippingRulesExist only if the token is WPS and not WPS subscription flow, or the token
                    // is instant update flow
                    // We have instant update flow check here to avoid making unnecessary calls to shippingRulesSummary
                    if (isSntSupported || $scope.checkoutCart.instantUpdateIntegration) {
                        var isSnTEnabled = void 0;
                        _logger.$logger.info('config_read_rules_summary', {
                            readRulesSummaryFromAppData: $config.readRulesSummaryFromAppData
                        });
                        if ($config.readRulesSummaryFromAppData) {
                            isSnTEnabled = $scope.checkoutAppData.is_snt_enabled();
                            setButtonParams(isSnTEnabled);
                        } else {
                            checkShippingRulesExist().then(function () {
                                isSnTEnabled = $scope.shippingRulesSummary && $scope.shippingRulesSummary.isSnTEnabled;
                                setButtonParams(isSnTEnabled);
                            });
                        }
                    }
                });

                // Change html dir attribute for RTL/LTR, append RTL styling if needed.
                function setDirectionality() {
                    $document.prop('documentElement').setAttribute('dir', $locale.metadata.directionality);
                }

                // Change html lang attribute and document title
                function localizeHead() {
                    $document.prop('documentElement').setAttribute('lang', $locale.lang);
                    setDirectionality();

                    var content = $renderContent('base.payPal');

                    if (content) {
                        $document.title = content;
                    }
                }

                function getPaymentMethod() {
                    var paymentMethodViaUrl = $util.param('paymentMethod');
                    var paymentMethodViaCheckoutAppData = $scope.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;

                    return paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
                }

                function checkUnbranded() {
                    var paymentMethod = getPaymentMethod();

                    if (!paymentMethod || !$config.allowedUnbrandedPayments) {
                        return false;
                    }

                    // If paymentMethod in URL is NOT in the list of allowed payment methods, return false
                    if ($config.allowedUnbrandedPayments.indexOf(paymentMethod) === -1) {
                        return false;
                    }

                    return true;
                }

                $scope.isUnbranded = checkUnbranded();

                $scope.paymentMethod = '';

                if ($scope.isUnbranded) {
                    $scope.paymentMethod = getPaymentMethod();

                    if ($scope.paymentMethod === 'invoice') {
                        $scope.unbrandedTitle = 'payUponInvoice.header';
                        $scope.unbrandedSubTitle = 'payUponInvoice.processedBy';
                    }
                }

                $scope.isApp = $DeviceInfo.isApp();

                var contentChange = $rootScope.$on('contentChange', localizeHead);

                localizeHead();

                var cancel = $rootScope.$on('allLoaded', function () {
                    angular.element('#preloaderSpinner').hide();

                    // Opera for Andriod has support for window.performance.timing but
                    // not for window.performance.now()
                    var loadTime = 'N/A';
                    if ('now' in performance) {
                        loadTime = performance.now();
                    } else if (['timeOrigin', 'timing'].some(function (key) {
                        return key in performance;
                    })) {
                        var _performance = performance,
                            timeOrigin = _performance.timeOrigin,
                            _performance$timing = _performance.timing,
                            timing = _performance$timing === undefined ? {} : _performance$timing;

                        var start = timeOrigin || timing.navigationStart;
                        loadTime = Date.now() - start;
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'BILLING',
                        to: 'prepare_billing_page_loaded',
                        page_load_time: loadTime
                    });
                    cancel();
                });

                $scope.$on('localeChange', function () {
                    localizeHead();
                    setLanguageToggleFlags();
                });

                $scope.$on('$destroy', function () {
                    cancel();
                    contentChange();
                });

                $document.bind('click', function (event) {
                    $scope.$broadcast('clickBody', event.target);
                });
            }
        };
    });
});

_fn.$fn;

_gdprCookieBanner.isGdprValid;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/directive.js
// module id = ./pages/xo-checkout/directive.js
// module chunks = 0